import { GRAMMAR, PLAGIARISM } from '@src/components/Cards/constants'
import { CardContent } from '@src/components/Editor/types'
import { IssueCategory } from '@src/components/Modals/PaperScorecardModal/types'
import { RawDraftContentState } from 'draft-js'
import { CommentsMap } from './actions'

export const EXPERT_CHECK = 'expert-check'

export interface FilteredComments {
  shown: CardContent[]
  hidden: CardContent[]
}

export type EXPERT_CHECK = typeof EXPERT_CHECK

export type CheckCategory = PLAGIARISM | GRAMMAR | EXPERT_CHECK

interface CheckCategories {
  spellcheck: CheckCategory
  wtai: CheckCategory
  language: CheckCategory
  plagiarism: CheckCategory
  rules: CheckCategory
  classifiers: CheckCategory
}

type CheckPriorityTypes = keyof Omit<CheckCategories, 'plagiarism'>

export type TypePriorities = { [key in CheckPriorityTypes]: number }

export interface PaperContent {
  version: string
  rawContentState: RawDraftContentState
  comments: CommentsMap
  plagiarismScore?: number
}

export interface IssueCategoryCount {
  issueCategory: IssueCategory
  count: number
}

export type IssueCategoryCounts = { [key in IssueCategory]?: number }



// WEBPACK FOOTER //
// ./src/state/document/types.ts